<template>
  <generic-container
    :title="$t('dynamic jwt access')"
    icon="key"
    :searchable="false"
    :show_refresh="true"
    @refresh="init"
    :show_plus="true"
    @add="add"
    :configurable="true"
    v-bind:configure_modal="configure_modal"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("create date") }}</th>
          <th>{{ $t("username") }}</th>
          <th>{{ $t("status") }}</th>
          <th>{{ $t("key") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <div class="ui info message" style="display: block">
      <div class="header">{{ $t("hints") }}</div>
      <ul class="list">
        <li
          v-html="
            $t('the url to generate token is') +
              ' <b>' +
              api_host +
              '/api_manager/jwt/generate</b>'
          "
        ></li>
        <li
          v-html="
            $t(
              'when requesting token, send the json structure below as the body',
            )
          "
        ></li>
        <li>
          <pre>{{ JSON.stringify(default_structure, null, 2) }}</pre>
        </li>
        <li
          v-html="
            $t('token must be sent on request header named api-access-token')
          "
        ></li>
      </ul>
    </div>
    <jwt-access-modal ref="jwt_access_modal" @saved="init" @deleted="init" />
  </generic-container>
</template>

<script>
import { enterprise_setup, init_ajax_data_datables, api_host } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import JwtAccessModal from "@/modules/api_manager/jwt_access_modal/Index";

// @ is an alias to /src
export default {
  name: "DynamicJWT",
  components: {
    "generic-container": GenericContainer,
    JwtAccessModal,
  },
  filters: filters,
  data() {
    return {
      api_host: api_host,
      configure_modal: ConfigureModal,
      default_structure: {
        username: "the username",
        key: "the security key",
        enterprise: "enterprise codename",
      },
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      let vm = this;
      vm.$refs.jwt_access_modal.show_modal();
    },
    translate_status(status_code) {
      let vm = this;
      switch (status_code) {
        case "A":
          return vm.$t("active");
        case "I":
          return vm.$t("inactive");
        default:
          return status_code;
      }
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function(row) {
            return filters.formatDate(
              row.create_date,
              vm.enterprise_setup.detailed_date_format,
            );
          },
        },
        {
          data: function(row) {
            return row.username;
          },
        },
        {
          data: function(row) {
            return vm.translate_status(row.status_code);
          },
        },
        {
          data: function(row) {
            return row.key;
          },
        },
      ];
      let onSelect = (data) => {
        vm.$refs.jwt_access_modal.show_modal(data.uuid);
      };
      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["api manager dynamic jwt access url"],
        columns,
        onSelect,
      );
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>
